/* eslint-disable @typescript-eslint/naming-convention */

// https://www.ospo.noaa.gov/products/land/hms.html#about
// https://www.usgs.gov/centers/eros/science/usgs-eros-archive-land-cover-products-global-land-cover-characterization-glcc?qt-science_center_objects=0#qt-science_center_objects
// https://www.usgs.gov/media/files/global-land-cover-characteristics-data-base-readme-version2 -- appendix 1
/**
 * Global Land Cover Characteristics Data Base Version 2.0
 * Appendix 1: Global Ecosystems Legend
 */
enum GlobalEcosystems {
  Urban = 1,
  LowSparseGrassland = 2,
  ConiferousForest = 3,
  DeciduousConiferForest = 4,
  DeciduousBroadleafForest = 5,
  EvergreenBroadleafForests = 6,
  TallGrassesAndShrubs = 7,
  BareDesert = 8,
  UplandTundra = 9,
  IrrigatedGrassland = 10,
  SemiDesert = 11,
  GlacierIce = 12,
  WoodedWetSwamp = 13,
  InlandWater = 14,
  SeaWater = 15,
  ShrubEvergreen = 16,
  ShrubDeciduous = 17,
  MixedForestAndField = 18,
  EvergreenForestAndFields = 19,
  CoolRainForest = 20,
  ConiferBorealForest = 21,
  CoolConiferForest = 22,
  CoolMixedForest = 23,
  MixedForest = 24,
  CoolBroadleafForest = 25,
  DeciduousBroadleafForest_2 = 26, // Note: Value 5 is also "Deciduous Broadleaf Forest"
  ConiferForest = 27,
  MontaneTropicalForests = 28,
  SeasonalTropicalForest = 29,
  CoolCropsAndTowns = 30,
  CropsAndTown = 31,
  DryTropicalWoods = 32,
  TropicalRainforest = 33,
  TropicalDegradedForest = 34,
  CornAndBeansCropland = 35,
  RicePaddyAndField = 36,
  HotIrrigatedCropland = 37,
  CoolIrrigatedCropland = 38,
  ColdIrrigatedCropland = 39,
  CoolGrassesAndShrubs = 40,
  HotAndMildGrassesAndShrubs = 41,
  ColdGrassland = 42,
  SavannaWoods = 43,
  MireBogFen = 44,
  MarshWetland = 45,
  MediterraneanScrub = 46,
  DryWoodyScrub = 47,
  DryEvergreenWoods = 48,
  VolcanicRock = 49,
  SandDesert = 50,
  SemiDesertShrubs = 51,
  SemiDesertSage = 52,
  BarrenTundra = 53,
  CoolSouthernHemisphereMixedForests = 54,
  CoolFieldsAndWoods = 55,
  ForestAndField = 56,
  CoolForestAndField = 57,
  FieldsAndWoodySavanna = 58,
  SucculentAndThornScrub = 59,
  SmallLeafMixedWoods = 60,
  DeciduousAndMixedBorealForest = 61,
  NarrowConifers = 62,
  WoodedTundra = 63,
  HeathScrub = 64,
  CoastalWetlandNW = 65,
  CoastalWetlandNE = 66,
  CoastalWetlandSE = 67,
  CoastalWetlandSW = 68,
  PolarAndAlpineDesert = 69,
  GlacierRock = 70,
  SaltPlayas = 71,
  Mangrove = 72,
  WaterAndIslandFringe = 73,
  LandWaterAndShore = 74,
  LandAndWaterRivers = 75,
  CropAndWaterMixtures = 76,
  SouthernHemisphereConifers = 77,
  SouthernHemisphereMixedForest = 78,
  WetSclerophylicForest = 79,
  CoastlineFringe = 80,
  BeachesAndDunes = 81,
  SparseDunesAndRidges = 82,
  BareCoastalDunes = 83,
  ResidualDunesAndBeaches = 84,
  CompoundCoastlines = 85,
  RockyCliffsAndSlopes = 86,
  SandyGrasslandAndShrubs = 87,
  Bamboo = 88,
  MoistEucalyptus = 89,
  RainGreenTropicalForest = 90,
  WoodySavanna = 91,
  BroadleafCrops = 92,
  GrassCrops = 93,
  CropsGrassShrubs = 94,
  EvergreenTreeCrop = 95,
  DeciduousTreeCrop = 96,
  InterruptedAreas = 99,
  MissingData = 100
}

export function glccLabel(code: GlobalEcosystems): string {
  const label = GlobalEcosystems[code];
  // convert from camel case to normal words with capitalized first letters
  return label.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, c => c.toUpperCase());
}